import { inject, Injectable } from '@angular/core';
import { ChatStoreService } from '../chat-store/chat-store.service';
import { HistoryEntry } from '../../model/history-entry';

@Injectable({ providedIn: 'root' })
/**
 * Service, der zu einer Nachricht die History aus dem ChatStore rekonstruiert.
 * Begründung: Technische Hilfsklasse (keine AFO).
 */
export class HistoryService {
  private readonly chatStoreService = inject(ChatStoreService);

  getHistory(refEventId: string): HistoryEntry[] {
    const history = [] as HistoryEntry[];
    const state = this.chatStoreService.getStateSync();

    const chatRoom = state.getCurrentRoom();
    if (!chatRoom) {
      console.warn('getHistory: ChatRoom nicht gefunden: eventId=', refEventId);
      return history;
    }
    const chatMessage = chatRoom.messages.find(message => message.first.getId() === refEventId);
    if (!chatMessage) {
      console.warn('getHistory: ChatMessage nicht gefunden: eventId=', refEventId);
      return history;
    }

    //Filter Duplicates, irgendwie kommen hier nach dem Login manche Einträge doppelt auf, sollte sich wenn weniger Druck ist nochmal in Ruhe angeschaut werden
    const messagesWithoutDuplicates = [...new Map(chatMessage.messages.map(message => [message.getId()!, message]))];

    for (let i = messagesWithoutDuplicates.length - 1; i > 0; --i) {
      const currEvent = messagesWithoutDuplicates[i];
      const prevEvent = messagesWithoutDuplicates[i - 1];
      const currText =
        currEvent[1].getContent()?.['m.new_content']['formatted_body'] ??
        currEvent[1].getContent()?.['m.new_content']['body'];
      const originalContent = prevEvent[1].getOriginalContent();
      const prevText =
        originalContent?.['m.new_content']?.formatted_body ??
        originalContent?.['formatted_body'] ??
        originalContent?.['m.new_content']?.body ??
        originalContent?.['body'];

      history.push({
        originalContent: prevText,
        newContent: currText,
        timestamp: currEvent[1].getDate()!.toISOString()
      });
    }

    return history;
  }
}
